import { render, staticRenderFns } from "./VitalDefaultList.vue?vue&type=template&id=947cbafc&lang=pug"
import script from "./VitalDefaultList.vue?vue&type=script&lang=js"
export * from "./VitalDefaultList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports